module.exports = __webpack_public_path__ + "static/media/classes.c8fdc3a0.jpg";